/******************
	* This is a basic wrapper around Axios for use in a project (AJAX requests)
	* Axios is a promised based XHR framework, its pretty easy to use,
	* but detailed instructions can be found here: https://github.com/axios/axios
	* Usage Example:
		import
		http.get('/api/someData')
			.then(res => {
				//request succeeded, do something with response
				console.log(`The response from the API is ${res}`)
			})
			.catch(err => {
				//request failed, do something with the error
				console.error(`There was an error: ${err}`)
			})
			.finally(() => {
				//do something always, regardless of success or failure 
			})

******************/
import { util } from '~/core';

import axios from 'axios'

export default class HTTP {
	constructor(opts = {}) {
		this.http = axios.create({})
	}

	async get(url, config = {}) {
		try {
			let res = await this.http.get(url, config)
			return res
		}
		catch(err) {
			console.error(err)
		}
	}

	async delete(url, config = {}) {
		try {
			let res = await this.http.delete(url)
			return res
		}
		catch(err) {
			console.error(err)
		}
	}

	async post(url, data = {}, config = {}) {
		try {
			let res = await this.http.post(url, data, config)
			return res
		}
		catch(err) {
			console.error(err)
		}
	}

	async put(url, data = {}, config = {}) {
		try {
			let res = await this.http.put(url, data, config)
			return res
		}
		catch(err) {
			console.error(err)
		}
	}
}

util.HTTP = HTTP